/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Rank_Movement_NoteInputs */

const th_rank_movement_note = /** @type {(inputs: Rank_Movement_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`การเปลี่ยนอันดับเปรียบเทียบรุ่นนี้กับก่อนวันแข่งขันล่าสุด (UTC)`)
};

const en_rank_movement_note = /** @type {(inputs: Rank_Movement_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Movement compares this division with its table before its latest match date (UTC).`)
};

const ja_rank_movement_note = /** @type {(inputs: Rank_Movement_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`順位変動は、この部門の最新試合日（UTC）より前の順位との比較です。`)
};

const zh_rank_movement_note = /** @type {(inputs: Rank_Movement_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`升降是将本分区与上一个比赛日（UTC）之前的积分榜相比得出的。`)
};

const es_rank_movement_note = /** @type {(inputs: Rank_Movement_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`El movimiento compara esta categoría con su tabla anterior a la última fecha de partido (UTC).`)
};

const pt_rank_movement_note = /** @type {(inputs: Rank_Movement_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`O movimento compara esta categoria com a tabela anterior à última data de jogo (UTC).`)
};

const id_rank_movement_note = /** @type {(inputs: Rank_Movement_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pergerakan membandingkan divisi ini dengan klasemennya sebelum hari pertandingan terakhir (UTC).`)
};

const fr_rank_movement_note = /** @type {(inputs: Rank_Movement_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`L’évolution compare cette catégorie à son classement avant sa dernière date de match (UTC).`)
};

const tl_rank_movement_note = /** @type {(inputs: Rank_Movement_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inihahambing ng galaw ang dibisyong ito sa talaan nito bago ang huling araw ng laro (UTC).`)
};

const vi_rank_movement_note = /** @type {(inputs: Rank_Movement_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mức thay đổi so bảng này với xếp hạng của nó trước vòng đấu gần nhất (UTC).`)
};

const ko_rank_movement_note = /** @type {(inputs: Rank_Movement_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`변동은 이 디비전을 지난 경기일(UTC) 이전 순위와 비교한 것입니다.`)
};

const de_rank_movement_note = /** @type {(inputs: Rank_Movement_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Die Veränderung vergleicht diese Klasse mit ihrer Tabelle vor dem letzten Spieltag (UTC).`)
};

const ru_rank_movement_note = /** @type {(inputs: Rank_Movement_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Изменение сравнивает этот дивизион с его таблицей до последнего игрового дня (UTC).`)
};

const tr_rank_movement_note = /** @type {(inputs: Rank_Movement_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Değişim, bu grubu son maç gününden (UTC) önceki puan durumuyla karşılaştırır.`)
};

const it_rank_movement_note = /** @type {(inputs: Rank_Movement_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`La variazione confronta questa categoria con la sua classifica prima dell'ultima giornata (UTC).`)
};

const pl_rank_movement_note = /** @type {(inputs: Rank_Movement_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zmiana porównuje tę grupę z jej tabelą sprzed ostatniej kolejki (UTC).`)
};

const uk_rank_movement_note = /** @type {(inputs: Rank_Movement_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Зміна порівнює цей дивізіон із його таблицею до останнього ігрового дня (UTC).`)
};

const hi_rank_movement_note = /** @type {(inputs: Rank_Movement_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`बदलाव इस वर्ग की तुलना पिछले मैच दिवस (UTC) से पहले की तालिका से करता है।`)
};

const ar_rank_movement_note = /** @type {(inputs: Rank_Movement_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`يقارن التغيّر هذه الفئة بترتيبها قبل آخر يوم مباريات (بتوقيت UTC).`)
};

const ms_rank_movement_note = /** @type {(inputs: Rank_Movement_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Perubahan membandingkan divisyen ini dengan kedudukannya sebelum hari perlawanan terakhir (UTC).`)
};

const bn_rank_movement_note = /** @type {(inputs: Rank_Movement_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`পরিবর্তন এই বিভাগকে শেষ খেলার দিনের (UTC) আগের তালিকার সঙ্গে তুলনা করে।`)
};

const zh_tw2_rank_movement_note = /** @type {(inputs: Rank_Movement_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`升降是將本分組與上一個比賽日（UTC）之前的積分榜相比得出的。`)
};

const zh_hk2_rank_movement_note = /** @type {(inputs: Rank_Movement_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`升降是將本組別與上一個比賽日（UTC）之前的積分榜相比得出的。`)
};

const ur_rank_movement_note = /** @type {(inputs: Rank_Movement_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`تبدیلی اس درجے کا موازنہ پچھلے میچ ڈے (UTC) سے پہلے کی فہرست سے کرتی ہے۔`)
};

const fa_rank_movement_note = /** @type {(inputs: Rank_Movement_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`تغییر، این گروه را با جدولش پیش از آخرین روز بازی (UTC) می‌سنجد.`)
};

const sw_rank_movement_note = /** @type {(inputs: Rank_Movement_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mabadiliko yanalinganisha daraja hili na msimamo wake kabla ya siku ya mwisho ya michezo (UTC).`)
};

const nl_rank_movement_note = /** @type {(inputs: Rank_Movement_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Het verschil vergelijkt deze klasse met haar stand vóór de laatste speeldag (UTC).`)
};

/**
* | output |
* | --- |
* | "Movement compares this division with its table before its latest match date (UTC)." |
*
* @param {Rank_Movement_NoteInputs} inputs
* @param {{ locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }} options
* @returns {LocalizedString}
*/
export const rank_movement_note = /** @type {((inputs?: Rank_Movement_NoteInputs, options?: { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Rank_Movement_NoteInputs, { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "th") return th_rank_movement_note(inputs)
	if (locale === "ja") return ja_rank_movement_note(inputs)
	if (locale === "zh") return zh_rank_movement_note(inputs)
	if (locale === "es") return es_rank_movement_note(inputs)
	if (locale === "pt") return pt_rank_movement_note(inputs)
	if (locale === "id") return id_rank_movement_note(inputs)
	if (locale === "fr") return fr_rank_movement_note(inputs)
	if (locale === "tl") return tl_rank_movement_note(inputs)
	if (locale === "vi") return vi_rank_movement_note(inputs)
	if (locale === "ko") return ko_rank_movement_note(inputs)
	if (locale === "de") return de_rank_movement_note(inputs)
	if (locale === "ru") return ru_rank_movement_note(inputs)
	if (locale === "tr") return tr_rank_movement_note(inputs)
	if (locale === "it") return it_rank_movement_note(inputs)
	if (locale === "pl") return pl_rank_movement_note(inputs)
	if (locale === "uk") return uk_rank_movement_note(inputs)
	if (locale === "hi") return hi_rank_movement_note(inputs)
	if (locale === "ar") return ar_rank_movement_note(inputs)
	if (locale === "ms") return ms_rank_movement_note(inputs)
	if (locale === "bn") return bn_rank_movement_note(inputs)
	if (locale === "zh-TW") return zh_tw2_rank_movement_note(inputs)
	if (locale === "zh-HK") return zh_hk2_rank_movement_note(inputs)
	if (locale === "ur") return ur_rank_movement_note(inputs)
	if (locale === "fa") return fa_rank_movement_note(inputs)
	if (locale === "sw") return sw_rank_movement_note(inputs)
	if (locale === "nl") return nl_rank_movement_note(inputs)
	return en_rank_movement_note(inputs)
});